// 小米-小部件
export default {
  // 印尼语
  "id-wi.comfortweather.com": {
    ad1: [
      {
        type: "ads",
        slot: 9558148636,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-05",
      },
      {
        type: "ads",
        slot: 2339237811,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-03",
      },
      {
        type: "ads",
        slot: 3098588043,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-04",
      },
      {
        type: "ads",
        slot: 7399992808,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-03",
      },
      {
        type: "ads",
        slot: 4964297508,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-27",
      },
      {
        type: "ads",
        slot: 9359107580,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-28",
      },
      {
        type: "ads",
        slot: 3460747793,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-29",
      },
      {
        type: "ads",
        slot: 2338134168,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-26",
      },
      {
        type: "ads",
        slot: 6409241110,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-03",
      },
    ],
  },
  // 西班牙语
  "es-wi.comfortweather.com": {
    ad1: [
      {
        type: "ads",
        slot: 4220098025,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-05",
      },
      {
        type: "ads",
        slot: 8843832765,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-03",
      },
      {
        type: "ads",
        slot: 2907016355,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-04",
      },
      {
        type: "ads",
        slot: 4904587758,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-03",
      },
      {
        type: "ads",
        slot: 4199114391,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-27",
      },
      {
        type: "ads",
        slot: 3591506082,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-28",
      },
      {
        type: "ads",
        slot: 6654689671,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-29",
      },
      {
        type: "ads",
        slot: 7946787714,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-26",
      },
      {
        type: "ads",
        slot: 5341608004,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-03",
      },
    ],
  },
};
